<template>
  <section>
    <social-header title="城市列表"></social-header>
    <div class="city-list">
      <p class="city-list-col" :class="{ selected: isSelected(item) }" v-for="item in cityList" :key="item.cityId"
        v-stat:click="{ name: 'choose' }">
        <a v-if="isSelected(item)" href="javascript:;"
          @click="changeUserCityThenGoActivityHomePage(item)">{{ item.cityName }}<em
            class="iconfont_M icon-select_M"></em></a>
        <a v-else href="javascript:;" @click="changeUserCityThenGoActivityHomePage(item)">{{ item.cityName }}</a>
      </p>
    </div>
    <social-dialog title="正在加载" category="tips" v-bind:show="isLoading"></social-dialog>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import SocialHeader from '../../components/social-header.vue'
import SocialDialog from '../../components/social-dialog.vue'

export default {
  components: {
    SocialHeader,
    SocialDialog
  },
  name: 'City',
  data: function () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      cityList: 'cityList'
    })
  },
  methods: {
    isSelected: function (city) {
      let userCity = this.$store.getters.userCity
      return city.cityId == userCity.cityId
    },
    changeUserCityThenGoActivityHomePage: function (city) {
      this.$store.dispatch('changeUserCity', {
        city: {
          cityId: city.cityId,
          cityName: city.cityName
        }
      })
      this.$router.go(-2)
    }
  },
  created: function () {
    this.isLoading = true
    let provinceId = this.$route.query.provinceId
    let that = this
    this.$store.dispatch('getProvinceCityList', { provinceId: provinceId }).then(() => {
      that.isLoading = false
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/activity/city.vue